// Mobile menu behavior.

import $ from 'jquery';

const toggleMobileMenu = expanded => {
  $('body').toggleClass('mobile-nav-open', expanded);
  $('.dialog-off-canvas-main-canvas > *:not(.navbar-dialog-wrapper)').attr(
    'aria-hidden',
    expanded ? 'true' : 'false'
  );

  const $navbar = $('.navbar').first();
  const $dialog = $('.navbar-dialog-wrapper').first();
  const $mainNav = $('#block-particle-mainnavigation').first();
  const $secondaryMenu = $('#block-secondarynavigation').first();
  const $optionsMenu = $('#block-optionsmenu').first();

  if (expanded) {
    // Move main navigation before secondary menu.
    $mainNav.insertBefore($secondaryMenu);

    // Turn navbar into dialog when expanded.
    $dialog.attr('role', 'dialog');
    $dialog.attr('aria-label', $dialog.data('dialog-label'));

    // Trap keyboard focus inside open mobile menu dialog.
    $navbar.on('focusout', e => {
      const navbarEl = $navbar[0];
      if (!$.contains(navbarEl, e.relatedTarget)) {
        console.log('trap focus');
        $(navbarEl)
          .find('.navbar-toggler')
          .first()
          .focus();
      }
    });

    // Close when ESC is pressed.
    $navbar.on('keyup', e => {
      console.log('keyup');
      if (e.keyCode === 27) {
        $('.navbar-toggler')
          .first()
          .click();
      }
    });
  } else {
    // Reset all state.
    $mainNav.insertAfter($optionsMenu);
    $('.navbar-dialog-wrapper').removeAttr('role');
    $('.navbar-dialog-wrapper').removeAttr('aria-label');
    $navbar.unbind('focusout').unbind('keyup');
  }
};

// Toggle mobile menu when Bootstrap toggle is activated.
$('#top-navigation')
  .on('show.bs.collapse', () => toggleMobileMenu(true))
  .on('hidden.bs.collapse', () => toggleMobileMenu(false));
